import { Component, OnInit, Inject, ViewEncapsulation, OnDestroy, AfterViewInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Subject } from 'rxjs';
import { UserService, ChangePhoneNumberStatus } from 'app/_shared/user.services';
import { FormGroup, FormBuilder, FormControl } from '@angular/forms';
import { OrderEvent } from './order-event.model';
import { OrdersOrderListService } from '../order-list.service';

@Component({
    selector: 'order-events-dialog',
    templateUrl: './order-events-dialog.component.html',
    styleUrls: ['./order-events-dialog.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class OrderEventsDialogComponent implements OnInit, OnDestroy, AfterViewInit {
    orderEvents: OrderEvent[];
    label: string;

    protected _unsubscribeAll = new Subject<void>();

    // Workaround for angular component issue #13870
    disableAnimation = true;

    form: FormGroup;

    constructor(
        public matDialogRef: MatDialogRef<OrderEventsDialogComponent>,
        @Inject(MAT_DIALOG_DATA) private _data: any,
        private _orderListService: OrdersOrderListService
    ) {
        this.label = _data.label;
    }
    ngOnInit(): void {
        this._orderListService.onOrderEventsChanged.subscribe(events => {
            this.orderEvents = events;
        });
    }

    ngAfterViewInit(): void {
        // timeout required to avoid the dreaded 'ExpressionChangedAfterItHasBeenCheckedError'
        setTimeout(() => (this.disableAnimation = false));
    }

    ngOnDestroy(): void {
        this._unsubscribeAll.next();
        this._unsubscribeAll.complete();
    }
}
